import { Col, Row, Tabs, Tab } from "react-bootstrap";
import StopRoute from "./StopRoute.jsx";
import StopMap, { StreetViewMap } from "./StopMap.jsx";
import useStopDetails from "../../hooks/useStopDetails.js";
import Alert from "../Alert.jsx";

export default function StopContainer({ stopId }) {
  const { stop, error, loading } = useStopDetails(stopId);
  const hasStop = Boolean(stop && Object.keys(stop).length > 0);
  const title = hasStop ? `Stop #${stop.stop_id} - ${stop.stop_name}` : "";
  const completionMessage = hasStop ? `${title} has finished loading.` : "";

  let content;
  if (!stopId) {
    content = <Alert variant="info">No stop selected.</Alert>;
  } else if (error) {
    content = <Alert variant="danger">Failed to load stop data.</Alert>;
  } else if (loading) {
    content = null;
  } else if (!hasStop) {
    content = <p>Detailed schedule information is not available for this stop.</p>;
  } else {
    // Sort routes by short name, then long name
    const stopRoutes = Object.values(stop.routes || {}).sort((a, b) =>
      String(a.route_short_name || "").localeCompare(
        String(b.route_short_name || ""),
        undefined,
        { numeric: true, sensitivity: "base" }
      )
    );

    content = (
      <Row className="ictapp__stops__details">
        <Col xs={12}>
          <h2 className="my-3">{title}</h2>
          <p>{stop.stop_desc}</p>
        </Col>
        <Col xs={12} className="mb-5">
          <Tabs defaultActiveKey="mapview">
            <Tab eventKey="mapview" title="View Stop Map" className="pb-3">
              <StopMap stop={stop} />
            </Tab>
            <Tab eventKey="streetview" title="See Street View">
              <StreetViewMap stop={stop} />
            </Tab>
          </Tabs>
        </Col>

        <Col xs={12}>

          <h3>Routes serving this stop:</h3>
          {stopRoutes.length === 0 && <p>No routes found for this stop.</p>}

          {/* <Row className="ictapp__stops__route"> */}
          {stopRoutes.map((route, index) => (
            <StopRoute
              key={route.route_id || `${route.route_short_name}-${index}`}
              route={route}
            />
          ))}
          {/* </Row> */}
        </Col>
      </Row >
    );
  }

  return (
    <>
      <Alert hidden>{completionMessage}</Alert>
      {content}
    </>
  );
}
